import React, { useEffect, useRef } from 'react';
import { useGoServerStore } from '../stores/goServerStore';

const BrowserTransitionHandler: React.FC = () => {
    const { salesCallStatus } = useGoServerStore();
    const wasVisible = useRef(document.visibilityState === 'visible');

    // Handle Visibility Change
    useEffect(() => {
        const handleVisibilityChange = () => {
            const isVisible = document.visibilityState === 'visible';

            if (!isVisible && wasVisible.current) {
                console.log('[BrowserTransitionHandler] Page hidden. Transitioning to background.');
                // Potentially pause heavy polling or non-critical updates here.
                // AudioContext checks could happen here if needed, but modern browsers usually handle tab muting.
            } else if (isVisible && !wasVisible.current) {
                console.log('[BrowserTransitionHandler] Page visible. checking state consistency.');
                // Verify connection is still alive if we think we are in a call
                if (salesCallStatus.isActive) {
                    console.log('[BrowserTransitionHandler] Resumed with active call state. Verifying connection...');

                    // Trigger active call check to re-sync with server state
                    // This handles cases where server might have restarted or call ended while backgrounded
                    // We use the store's checkActiveCall method if available, or just rely on the periodic check to catch up
                    // But explicitly triggering it here is faster.
                    useGoServerStore.getState().checkActiveCall();
                }
            }

            wasVisible.current = isVisible;
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [salesCallStatus.isActive]);

    // Handle Restore / Hydration check on mount
    useEffect(() => {
        if (salesCallStatus.isActive) {
            console.log('[BrowserTransitionHandler] App mounted with active call state. Restoring session...');
            // Logic to reconnect or validate session could go here
        }
    }, []);

    return null; // This component does not render anything
};

export default BrowserTransitionHandler;
